import { render, staticRenderFns } from "./CommRead.vue?vue&type=template&id=22e5ac0f&"
import script from "./CommRead.vue?vue&type=script&lang=js&"
export * from "./CommRead.vue?vue&type=script&lang=js&"
import style0 from "./CommRead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports